/**
 * Detect mobile phones (iPhone, Android phones) — excludes iPads and desktops.
 *
 * iPads report as "Macintosh" in modern Safari (requestDesktop UA), so we
 * distinguish them from real Macs via `navigator.maxTouchPoints > 1`.
 * Only small-screen touch devices are considered "mobile phones".
 *
 * Result is cached after first call — safe to call on every render.
 */

let cached: boolean | undefined;

export function isMobilePhone(): boolean {
  if (cached !== undefined) return cached;

  const ua = navigator.userAgent;

  // iPhone / iPod — always a phone
  if (/iPhone|iPod/i.test(ua)) {
    cached = true;
    return true;
  }

  // Android — phone if "Mobile" token present (tablets omit it)
  if (/Android/i.test(ua) && /Mobile/i.test(ua)) {
    cached = true;
    return true;
  }

  // Everything else (iPad, Mac, Windows, Linux) → not a phone
  cached = false;
  return false;
}
